import * as z from 'zod/v4';

export const BET_PROPS = [
  'ANDELSSPEL',
  'BEFORE_DRAW_OPEN',
  'BOLAG',
  'CALLCENTER',
  'COMPETITION',
  'EDITED_IN_TERMINAL',
  'EGNARADER',
  'EXTDEF_LIVE_EV',
  'EXTRA_SELECTION',
  'FIRST_SPLIT_WAGER',
  'FRACTION',
  'FRACTION_HOLDER',
  'FREEPLAY',
  'GROUP',
  'GROUP_B2C',
  'LARGE_NUMBERGAMEBET',
  'LIVESPEL',
  'LIVE_PREMATCH_COMB',
  'NO_COUPON',
  'OWNDEF_LIVE_EV',
  'PROLONGATION',
  'REDUCERA_FRITT',
  'SELF_SERVICE',
  'SKYLTSPEL',
  'SMALL_NUMBERGAMEBET',
  'SNABBSPEL',
  'SUBSCRIPTION',
  'USE_REPLACEMENT',
  'XLARGE_NUMBERGAMEBET',
  'XPERTEN',
  'XXLARGE_NUMBERGAMEBET',
  'UNKNOWN',
] as const;

// Unrecognized bet properties degrade to UNKNOWN instead of failing the whole wager.
export const betPropsEnum = z.enum(BET_PROPS).catch('UNKNOWN');

export type BetProp = z.infer<typeof betPropsEnum>;
